import { useSyncExternalStore } from 'react';
const subscribe = () => () => {};
const getSnapshot = () => true;
const getServerSnapshot = () => false;

/** False on the server and during hydration, true afterwards. */
export const useIsHydrated = () => {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};